import type { FC, PropsWithChildren } from 'react';

import { isCompetitorVideogame } from 'app/utils/videogame';

interface Props {
  videogame: VideogameSlug;
  forceDisplay?: boolean;
}

const PandascoreVideogameFeature: FC<PropsWithChildren<Props>> = ({
  videogame,
  forceDisplay = false,
  children
}) => {
  if (!forceDisplay && isCompetitorVideogame(videogame)) {
    return null;
  }

  return <>{children}</>;
};

PandascoreVideogameFeature.displayName = 'PandascoreVideogameFeature';

export default PandascoreVideogameFeature;
